import React, { PropsWithChildren, useState } from "react";
import { Modal } from "@mui/material";
import { ModalBox } from "./modal-box.component";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faX } from "@fortawesome/free-solid-svg-icons";
import { useWhiteLabelContext } from "../../../WhiteLabelContext";

export interface Dialog_VM {
  isOpen: boolean;
  openDialog: () => void;
  closeDialog: () => void;
}

export function useDialog(): Dialog_VM {
  const [open, setOpen] = useState<boolean>(false);
  const openDialog = () => setOpen(true);
  const closeDialog = () => setOpen(false);

  return {
    isOpen: open,
    openDialog,
    closeDialog,
  };
}

export interface DialogFrameProps extends PropsWithChildren {
  dialogOption: Dialog_VM;
  onClose?: (e: React.MouseEvent<HTMLElement>) => void;
  /**
   * Extra classes for the ModalBox itself (its width/min-width), for a
   * dialog that must fit a phone screen: ModalBox's min-w-[400px] overflows
   * a 375px viewport. Opt-in per dialog; omitted = the exact current box.
   */
  boxClassName?: string;
}

export function DialogFrame({
  dialogOption,
  onClose,
  children,
  boxClassName,
}: DialogFrameProps) {
  const { whiteLabel } = useWhiteLabelContext();
  return (
    <>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={dialogOption.isOpen}
        onClose={() => {}}
      >
        {/* @ts-ignore */}
        <ModalBox
          className={"relative" + (boxClassName ? ` ${boxClassName}` : "")}
          onClick={(e) => e.stopPropagation()}
          style={{
            "--primary": whiteLabel.colorHex,
            "--primary-bg": `${whiteLabel.colorHex}10`,
          } as React.CSSProperties}
        >
          <div className={"absolute z-10 right-0 top-0"}>
            <button
              onClick={(e) => {
                dialogOption.closeDialog();
                if (onClose) onClose(e);
              }}
              className={"!h-8 !w-8 z-40"}
            >
              <FontAwesomeIcon
                className={"text-sm"}
                style={{ fontSize: 10, lineHeight: 10 }}
                icon={faX}
              />
            </button>
          </div>
          {children}
        </ModalBox>
      </Modal>
    </>
  );
}
